import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
        <div>
          <h2 className="text-xl font-700 text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 text-sm text-foreground-600 transition-colors hover:text-primary-700 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}